// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"e19e813a","453":"64aababc"}[chunkId] + ".chunk.js";
};